var step15_interval = null,
	touch_not_x = -1,
	touch_not_y = -1,
	touch_not_t = -1,
	touch_not_tm = null;

function touch_notebook_end() {
	touch_not_x = -1;
	touch_not_y = -1;
	touch_not_t = -1;
	let n_act = $('#step15 .notebook_act'), oldLeft = n_act.css('left');
	n_act.css({left: ''});
	if (oldLeft != n_act.css('left')) {
		n_act.parent().addClass('anim');
	}

}

$(document).ready(function () {
	$('#step15 .notebook').on('transitionend', function (e) {
		$('.notebook_wraper.anim').removeClass('anim');
		$('.left_ani1').removeClass('left_ani1').css({'display': ''});
		$('.left_ani2').removeClass('left_ani2');
		$('#step16').css({'height': '', 'overflow': ''});
		if (touch_not_tm) window.clearTimeout(touch_not_tm);
	});
	$('#step15 .data').on('mousedown touchstart', function (e) {
		if (touch_not_tm) window.clearTimeout(touch_not_tm);
		touch_not_tm = window.setTimeout(touch_end, 1000);
		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		touch_not_x = touch.pageX;
		touch_not_y = touch.pageY;
		touch_not_t = 0;
	}).on('mousemove touchmove', function (e) {

		if (touch_not_t == 1 || touch_not_x == -1) return; // top-botom
		if (touch_not_t == 2) e.preventDefault(); // left-right
		if (touch_not_t == -1) return; // for mouse
		var touch = e;
		if (e.type == 'touchmove') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		this_x = touch.pageX;
		this_y = touch.pageY;

		if (touch_not_t == 0) {
			if (Math.abs(this_x - touch_not_x) > Math.abs(this_y - touch_not_y) + 2) {
				touch_not_t = 2;
				e.preventDefault();
			} else if (Math.abs(this_x - touch_not_x) + 2 < Math.abs(this_y - touch_not_y)) {
				touch_not_t = 1;
				return;
			} else {
				return;
			}
		}
		if (touch_not_tm) window.clearTimeout(touch_not_tm);
		touch_not_tm = window.setTimeout(touch_notebook_end, 1000);
		if (this_x - touch_not_x > 50) {
			$('#step15 .notebook_act').css({left: ''}).parent().addClass('anim');
			$('#step15 .more_left').trigger('click');
			touch_notebook_end();
			return;
		}
		if (this_x - touch_not_x < -50) {
			$('#step15 .notebook_act').css({left: ''}).parent().addClass('anim');
			$('#step15 .more_right').trigger('click');
			touch_notebook_end();
			return;
		}
		$('#step15 .notebook_act').css({left: this_x - touch_not_x}).parent().addClass('anim');
	}).on('mouseup', touch_notebook_end).css({cursor: 'move'}).css({cursor: '-moz-grabbing'}).css({cursor: '-webkit-grabbing'});

	if ($('#step15').length && $('body').hasClass('home')) {
		window.setTimeout(function () {
			$('#step15 .pages a:first').trigger('click');
		}, $(window).width() < 768 ? 1000 : 3000);
	}
	if ($('#step15').length) {

		$('#step15 .pages a').on('click', function () {
			if (!window.allow_slide) return false;
			var i = $('#step15 .pages a.act').removeClass('act').attr('rel');
			$('#ib' + i).addClass('left_ani1').removeClass('notebook_act');
			$('#ia' + i).removeClass('act');
			$('#step16').css({'height': $('#id' + i).outerHeight() + 'px', 'overflow': 'hidden'});
			$('#id' + i).addClass('left_ani1').removeClass('data_act');
			var i_fl = false;
			$(this).addClass('act');
			$('#step15 .pages a').each(function () {
				if (step15_interval) window.clearInterval(step15_interval);
				step15_interval = window.setInterval(function () {
					if ($('.notebook_act div').hasClass('alt')) $('.notebook_act div').toggleClass('a1').toggleClass('a2');
				}, 10000);
				i = $(this).attr('rel');
				if ($(this).hasClass('act')) {
					i_fl = true;
					$('#id' + i).css({'display': 'flex'});
					$('#step16').css({'height': $('#id' + i).outerHeight() + 'px'});
					$('#id' + i).addClass('left_ani1').addClass('data_act').removeClass('data_l').removeClass('data_r');
					$('#ia' + i).addClass('act').addClass('r_act');
					$('#ib' + i).addClass('left_ani1').addClass('notebook_act').removeClass('notebook_l').removeClass('notebook_r');
				} else if (i_fl) {
					$('#ib' + i).addClass('notebook_r').removeClass('notebook_act').removeClass('notebook_l');
					$('#ia' + i).removeClass('act').removeClass('r_act');
					$('#id' + i).addClass('data_r').removeClass('data_act').removeClass('data_l');
				} else {
					$('#ib' + i).addClass('notebook_l').removeClass('notebook_act').removeClass('notebook_r');
					$('#ia' + i).removeClass('act').removeClass('r_act');
					$('#id' + i).addClass('data_l').removeClass('data_act').removeClass('data_r');
				}
			});
			$('#step15 .notebook_wraper').addClass('anim');
			return false;
		});

		$('#step15 .more_right').on('click', function () {
			if ($('#step15 .pages a.act').next().length) $('#step15 .pages a.act').next().trigger('click'); else $('#step15 .pages a:first').trigger('click');
			return false;
		});
		$('#step15 .more_left').on('click', function () {
			if ($('#step15 .pages a.act').prev().length) $('#step15 .pages a.act').prev().trigger('click'); else $('#step15 .pages a:last').trigger('click');
			return false;
		});
		$(document).on('keydown', function (e) {
			if (e == null) keycode = event.keyCode; else keycode = e.which;
			if (e.target && e.target.type == 'text' || e.target.type == 'textarea') return true;
			if (keycode == 32 || keycode == 39) { // next
				if ($('#step15 .pages a.act').next().length) $('#step15 .pages a.act').next().trigger('click'); else $('#step15 .pages a:first').trigger('click');
				return false;
			}
			if (keycode == 37) { // prev
				if ($('#step15 .pages a.act').prev().length) $('#step15 .pages a.act').prev().trigger('click'); else $('#step15 .pages a:last').trigger('click');
				return false;
			}
		});
		step15_interval = window.setInterval(function () {
			if ($('.notebook_act div').hasClass('alt')) $('.notebook_act div').toggleClass('a1').toggleClass('a2');
		}, 10000);
	}
});